// React
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Styles
import '../styles/Code.css';

// Components
import MissionHeader from '../components/MissionHeader';
import MainButton from '../components/MainButton';
import Spinner from '../components/Spinner';

const Code: React.FC = () => {
    const correctCode = 'FBI';
    const spinnerVariant = [
        'A',
        'B',
        'C',
        'D',
        'E',
        'F',
        'G',
        'H',
        'I',
        'J',
        'K',
        'L',
        'M',
        'N',
        'O',
        'P',
        'Q',
        'R',
        'S',
        'T',
        'U',
        'V',
        'W',
        'X',
        'Y',
        'Z',
    ];
    const [spinnerFinalValues, setSpinnerFinalValues] = useState<string[]>(['A', 'B', 'C']);
    const [showCoffreOpen, setShowCoffreOpen] = useState<boolean>(false);
    const navigate = useNavigate();
    const [wrongIndices, setWrongIndices] = useState<number[]>([]);

    //  Fonction pour mettre à jour la valeur finale du spinner à un index donné
    const UpdateSpinnerFinalValue = (index: number, value: string) => {
        const newValues = [...spinnerFinalValues];
        newValues[index] = value;
        setSpinnerFinalValues(newValues);
    };

    //  Fonction pour gérer la validation du code
    const handleCodeEntry = () => {
        // Vérifie si le code est correct en joignant les valeurs des spinners
        const isCodeCorrect = spinnerFinalValues.join('') === correctCode;

        if (isCodeCorrect) {
            // Si le code est correct, afficher le coffre ouvert
            setShowCoffreOpen(true);
        } else {
            // Si le code est incorrect, indiquer les indices erronés avec une couleur rouge
            setWrongIndices([]);
            spinnerFinalValues.forEach((value, index) => {
                if (value !== correctCode[index]) {
                    setWrongIndices((prev) => [...prev, index]);
                }
            });

            // Faire disparaître la couleur rouge des indices erronés après 500ms
            setTimeout(() => {
                setWrongIndices([]);
            }, 500);
        }
    };

    return (
        <div className='code-page-container'>
            {showCoffreOpen && (
                <div className='code-page-coffre-open'>
                    <img
                        src='./images/logo.png'
                        alt='logo FBI'
                        className='code-page-logo-img'
                    />
                    <img
                        src='./images/coffre.png'
                        alt='Coffre Open'
                        className='code-page-coffre-open-img'
                    />
                    <MainButton
                        text='Fermer'
                        backgroundColor='secondary'
                        onClick={() => {
                            setShowCoffreOpen(false);
                            navigate(-1);
                        }}
                    />
                </div>
            )}
            {!showCoffreOpen && (
                <MissionHeader
                    showBackButton={false}
                    showCloseButton={true}
                    showSettingsButton={false}
                />
            )}
            <div className='code-page-content'>
                <div className='code-page-imgs'>
                    <img
                        src='./images/box-icon.png'
                        alt='Box Icon'
                        className='code-page-img-1'
                    />
                    <img
                        src='./images/bottle-icon.png'
                        alt='Bottle Icon'
                        className='code-page-img-2'
                    />
                    <img
                        src='./images/couche-icon.png'
                        alt='Couche Icon'
                        className='code-page-img-3'
                    />
                </div>
                <div className='code-page-spinner-content'>
                    <Spinner
                        spinnerContent={spinnerVariant}
                        initialIndex={0}
                        setSpinnerFinalValue={(value: string) => UpdateSpinnerFinalValue(0, value)}
                        isWrong={wrongIndices.includes(0) ? true : false}
                    />

                    <Spinner
                        spinnerContent={spinnerVariant}
                        initialIndex={1}
                        setSpinnerFinalValue={(value: string) => UpdateSpinnerFinalValue(1, value)}
                        isWrong={wrongIndices.includes(1) ? true : false}
                    />

                    <Spinner
                        spinnerContent={spinnerVariant}
                        initialIndex={2}
                        setSpinnerFinalValue={(value: string) => UpdateSpinnerFinalValue(2, value)}
                        isWrong={wrongIndices.includes(2) ? true : false}
                    />
                </div>
            </div>
            {/* Afficher le bouton de validation que si le coffre est ouvert */}
            {!showCoffreOpen && (
                <MainButton
                    text='Valider'
                    backgroundColor='primary'
                    onClick={() => {
                        handleCodeEntry();
                    }}
                />
            )}
        </div>
    );
};

export default Code;
